export default __webpack_public_path__ + "static/media/activities.1c9d8ba5.svg";